/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { loadCldr, L10n } from '@syncfusion/ej2-base';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';

import { useSelector } from 'react-redux';

import { DateTimeWrapper } from './styles';

const DateTime = ({ onChange, className, value, error }) => {
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const language = selectedDefaultLanguage.split('-')[0];
  loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require(`cldr-data/main/es/ca-gregorian.json`),
    require(`cldr-data/main/es/numbers.json`),
    require(`cldr-data/main/es/timeZoneNames.json`),
    require(`cldr-data/main/en/ca-gregorian.json`),
    require(`cldr-data/main/en/numbers.json`),
    require(`cldr-data/main/en/timeZoneNames.json`),
    require(`cldr-data/main/fr/ca-gregorian.json`),
    require(`cldr-data/main/fr/numbers.json`),
    require(`cldr-data/main/fr/timeZoneNames.json`),
    require(`cldr-data/main/it/ca-gregorian.json`),
    require(`cldr-data/main/it/numbers.json`),
    require(`cldr-data/main/it/timeZoneNames.json`),
    require(`cldr-data/main/ca/ca-gregorian.json`),
    require(`cldr-data/main/ca/numbers.json`),
    require(`cldr-data/main/ca/timeZoneNames.json`)
  );
  L10n.load({
    es: {
      datetimepicker: {
        today: 'Hoy',
      },
    },
    en: {
      datetimepicker: {
        today: 'Today',
      },
    },
    fr: {
      datetimepicker: {
        today: "Aujourd'hui'",
      },
    },
    ca: {
      datetimepicker: {
        today: 'Avui',
      },
    },
    it: {
      datetimepicker: {
        today: 'Oggi',
      },
    },
  });
  return (
    <DateTimeWrapper
      className={classNames(
        {
          'form__form-group-field': true,
          'form__form-group-field--error': error,
        },
        className
      )}
    >
      <DateTimePickerComponent
        id="datetimepicker"
        onChange={onChange}
        value={value}
        locale={language}
        firstDayOfWeek={1}
      />
    </DateTimeWrapper>
  );
};

DateTime.defaultProps = {
  className: '',
  onChange: undefined,
  value: undefined,
  error: false,
};

DateTime.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.instanceOf(Date),
  ]),
};

export default DateTime;
